export const SPAM_WORD_CATEGORY = [
  {
    value: 'Urgency',
    title: 'Urgency 🚨',
    score: 5,
    color: '#f77171',
  },
  {
    value: 'Shady',
    title: 'Shady 🔞',
    score: 10,
    color: '#f8a9d4',
  },
  {
    value: 'Overpromise',
    title: 'Overpromise 🤩',
    score: 5,
    color: '#fcba74',
  },
  {
    value: 'Money',
    title: 'Money 💰',
    score: 10,
    color: '#fcd34c',
  },
  {
    value: 'Unnatural',
    title: 'Unnatural 💬',
    score: 1,
    color: '#d1d5db',
  },
];

export const renderCategoryWithEmoji = category => {
  return SPAM_WORD_CATEGORY.find(item => item.value === category).title;
};
